{
  "version": 1,
  "asset_id": "3184f1ef-cc9c-455c-a924-10256e8afa1d",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/3184f1ef-cc9c-455c-a924-10256e8afa1d/palworld-trial-deck-green-purple-trim.png",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/3184f1ef-cc9c-455c-a924-10256e8afa1d/palworld-trial-deck-green-purple-trim.png",
  "original_filename": "palworld-trial-deck-green-purple-trim.png",
  "size": 694214,
  "content_type": "image/png",
  "created_at": "2026-08-02T02:01:55Z"
}
